<!-- commenting out this feature not requried -->
<button #trigger class="btn btn-block dialog-trigger plp-filterBy" (click)="launch()">
  Filter By
</button>

<app-facet-active-kb></app-facet-active-kb>
@if (isOpen$ | async) {
  <app-facet-list-kb [isDialog]="hasTrigger" (closeList)="close()"
  [class.active]="isActive$ | async" [class.dialog]="hasTrigger"></app-facet-list-kb>
}